import React, { useState } from "react";
import { useStyles } from "./styles";
import { useLocale } from "../../../../../providers/LocaleProvider";

interface DeleteFriendModalProps {
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => void;
    friendName: string;
}

export const DeleteFriendModal: React.FC<DeleteFriendModalProps> = ({
    isOpen,
    onOpenChange,
    onConfirm,
    friendName,
}) => {
    const classes = useStyles();
    const [isDeleting, setIsDeleting] = useState(false);

    const {
        friends: {
            modalDelete: {
                title,
                textModal1,
                textModal2,
                textModal3,
                removing,
                remove,
                cancel,
            },
        },
    } = useLocale();

    const handleConfirm = async () => {
        try {
            setIsDeleting(true);
            await onConfirm();
            onOpenChange(false);
        } catch (error) {
            console.error('Error deleting friend:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className={classes.overlay} onClick={() => !isDeleting && onOpenChange(false)}>
            <div className={classes.modal} onClick={(e) => e.stopPropagation()}>
                <div className={classes.header}>
                    <h2 className={classes.title}>{title("Remove Frienemy")}</h2>
                    <p className={classes.description}>
                        {textModal1("Are you sure you want to remove")} {friendName} {textModal2("from your frienemies list?")}
                        {textModal3("This action cannot be undone.")}
                    </p>
                </div>
                <div className={classes.footer}>
                    <button
                        className={`${classes.button} ${classes.cancelButton}`}
                        onClick={() => onOpenChange(false)}
                        disabled={isDeleting}
                    >
                        {cancel("Cancel")}
                    </button>
                    <button
                        className={`${classes.button} ${classes.removeButton}`}
                        onClick={handleConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? removing("Removing...") : remove("Remove")}
                    </button>
                </div>
            </div>
        </div>
    );
};